var exports = {
  "i": "x93eb46d8--5e24b4--wrapper",
  "z": "x93eb46d8--5e24b4--root",
};

module.exports = exports;
